function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.3781 11.1953H37.3951C37.3951 11.1953 18.7107 11.1953 14.701 11.1953C10.6914 11.1953 5.99999 14.3605 6 22.8192C6.00001 31.2779 9.9122 34.1077 14.701 34.4068C19.4898 34.7059 44.6188 34.5523 44.6188 34.5523V50.8149C44.6188 50.8149 44.6188 87.8513 44.6188 98.311C44.6188 102.942 50.6413 105.533 57.3781 104.587",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.6219 3H88.6049C88.6049 3 107.289 3 111.299 3C115.309 3 120 6.16519 120 14.6239C120 23.0826 116.088 25.9124 111.299 26.2115C106.51 26.5106 81.3812 26.357 81.3812 26.357V42.6195C81.3812 42.6195 81.3812 79.656 81.3812 90.1157C81.3812 94.7463 75.3587 97.3374 68.6219 96.3915",
  stroke: "#848688",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1055 19.0146C61.1055 19.001 61.1073 18.9875 61.111 18.9744L64.6331 6.31985C64.6799 6.15169 64.9276 6.18552 64.9276 6.36007V86.6517C64.9276 86.6651 64.9258 86.6784 64.9223 86.6913L61.4002 99.5799C61.354 99.7487 61.1055 99.7153 61.1055 99.5404V19.0146Z",
  fill: "white",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M127.851 49.7891H122.367V65H120.128V49.7891H114.656V47.9375H127.851V49.7891ZM153.859 57.0195C153.859 58.6914 153.578 60.1523 153.015 61.4023C152.453 62.6445 151.656 63.5938 150.625 64.25C149.593 64.9062 148.39 65.2344 147.015 65.2344C145.672 65.2344 144.48 64.9062 143.441 64.25C142.402 63.5859 141.593 62.6445 141.015 61.4258C140.445 60.1992 140.152 58.7812 140.136 57.1719V55.9414C140.136 54.3008 140.422 52.8516 140.992 51.5938C141.562 50.3359 142.367 49.375 143.406 48.7109C144.453 48.0391 145.648 47.7031 146.992 47.7031C148.359 47.7031 149.562 48.0352 150.601 48.6992C151.648 49.3555 152.453 50.3125 153.015 51.5703C153.578 52.8203 153.859 54.2773 153.859 55.9414V57.0195ZM151.621 55.918C151.621 53.8945 151.215 52.3438 150.402 51.2656C149.59 50.1797 148.453 49.6367 146.992 49.6367C145.57 49.6367 144.449 50.1797 143.629 51.2656C142.816 52.3438 142.398 53.8438 142.375 55.7656V57.0195C142.375 58.9805 142.785 60.5234 143.605 61.6484C144.433 62.7656 145.57 63.3242 147.015 63.3242C148.468 63.3242 149.593 62.7969 150.39 61.7422C151.187 60.6797 151.597 59.1602 151.621 57.1836V55.918ZM179.375 49.7891H173.891V65H171.652V49.7891H166.18V47.9375H179.375V49.7891ZM201.071 60.5469H193.922L192.317 65H189.996L196.512 47.9375H198.481L205.008 65H202.7L201.071 60.5469ZM194.602 58.6953H200.403L197.496 50.7148L194.602 58.6953ZM220.247 63.1602H228.333V65H217.985V47.9375H220.247V63.1602Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M130.362 82.4546H123.176V102H118.342V82.4546H111.252V78.5391H130.362V82.4546ZM157.809 91.8325H148.528V98.1167H159.42V102H143.694V78.5391H159.388V82.4546H148.528V88.0459H157.809V91.8325ZM186.061 97.166H177.586L175.974 102H170.834L179.568 78.5391H184.047L192.829 102H187.689L186.061 97.166ZM178.891 93.2505H184.756L181.807 84.4688L178.891 93.2505ZM211.897 78.5391L217.923 95.5547L223.917 78.5391H230.266V102H225.416V95.5869L225.899 84.5171L219.567 102H216.247L209.931 84.5332L210.414 95.5869V102H205.58V78.5391H211.897Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0.5,
  y: 8.69531,
  width: 62.3783,
  height: 104.585,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 63.1211,
  y: 0.5,
  width: 62.3783,
  height: 104.585,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgTotalTeamLogo = function SvgTotalTeamLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 114,
    viewBox: "0 0 249 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotalTeamLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-team-logo.e5efcc8d.svg";
export { ForwardRef as ReactComponent };